import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { PageTransition } from "../components/ui/PageTransition";

/**
 * The limit on businesses and personal books, stated as the rule (LF-168).
 *
 * The route carries no state and can be opened directly, so the page says the
 * rule, never that this login has reached it; its promise is the support reply
 * row's own ("we will write back with what is possible"). No plan, no list.
 */
export function UpgradePage(): ReactNode {
  return (
    <main className="legal-page">
      <PageTransition>
        <div className="legal-content">
          <h1>The limit on businesses and personal books</h1>

          <p>
            A login has a limit on the number of businesses or personal books it can set up. If you
            need another, write to support@eledger.com and we will write back with what is possible.
          </p>
          <p>
            <a href="mailto:support@eledger.com">support@eledger.com</a>
          </p>

          <p>
            <Link to="/clients">Back to your businesses</Link>
          </p>
        </div>
      </PageTransition>
    </main>
  );
}
